import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, ROLE_LEVEL } from "@/lib/api";

const AuthCtx = createContext(null);
const KEY = "ranger.activeCommunity";

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [activeId, setActiveId] = useState(() => localStorage.getItem(KEY));

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setSession(data);
    } catch {
      setSession(false);
    }
  }, []);

  useEffect(() => {
    load();
    const onLogout = () => setSession(false);
    window.addEventListener("ranger:logout", onLogout);
    return () => window.removeEventListener("ranger:logout", onLogout);
  }, [load]);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setSession(false);
  }, []);

  const value = useMemo(() => {
    const communities = session ? session.communities : [];
    const active = communities.find((c) => c.id === activeId) || communities[0] || null;
    const level = active ? ROLE_LEVEL[active.role] : 0;
    return {
      session, user: session ? session.user : session, communities, active, level,
      can: (role) => level >= ROLE_LEVEL[role],
      setActive: (id) => { localStorage.setItem(KEY, id); setActiveId(id); },
      setSession, reload: load, logout,
    };
  }, [session, activeId, load, logout]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
